<template>
  <div class="container">
    <div class="handle-box">
      <el-input v-model="query.recharge" placeholder="充值金额" class="handle-input mr10"></el-input>
      <el-select v-model="query.is_validate" clearable placeholder="是否有效" class="handle-select mr10">
        <el-option key="1" label="有效" value="1"></el-option>
        <el-option key="2" label="无效" value="0"></el-option>
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="handleAdd">添加</el-button>
    </div>
    <el-table :data="tableData" border class="table" ref="multipleTable" header-cell-class-name="table-header">
      <el-table-column prop="id" label="ID" align="center"></el-table-column>
      <el-table-column label="充值金额(元)" align="right">
        <template #default="scope">
          {{ parseFloat(scope.row.recharge / 100).toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column label="到账金额(元)" align="right">
        <template #default="scope">
          {{ parseFloat(scope.row.deposit / 100).toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column prop="store_id" label="门店/平台" align="center">
        <template #default="scope">
          <span>{{ storeMap.get(scope.row.store_id) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="是否有效" align="center">
        <template #default="scope">
          <el-button type="text" :style="'color:' + [!scope.row.is_validate ? 'red' : '']"
            @click="setIsvalidate(scope.$index, scope.row.id, !scope.row.is_validate)">
            {{ scope.row.is_validate ? "有效" : "无效" }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column prop="c_at" label="创建时间" :formatter="dateFormat" align="center" />
      <el-table-column label="操作" align="center">
        <template #default="scope">
          <el-button type="text" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)">编辑
          </el-button>
          <el-button type="text" icon="el-icon-delete" class="red" @click="handleDelete(scope.row.id)">删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination background layout="total, prev, pager, next" :current-page="query.page"
        :page-size="query.page_size" :total="pageTotal" @current-change="handlePageChange"></el-pagination>
    </div>
    <!-- 编辑弹出框 -->
    <el-dialog :title="actTitle" v-model="editVisible" width="30%">
      <el-form ref="form" :model="form" class="el-dialog__body model-h">

        <el-form-item label="充值金额" required>
          <el-input-number v-model="form.recharge" :precision="2" :min="0" :controls="false" :max="4294967295" />
          元
        </el-form-item>
        <el-form-item label="到账金额" required>
          <el-input-number v-model="form.deposit" :precision="2" :min="0" :controls="false" :max="4294967295" />
          元
        </el-form-item>
        <el-form-item label="使用门店" required>
          <el-select v-model="form.store_id" placeholder="请选择" style="width: 200px;">
            <el-option v-for="item in storeOptions" :key="item.value" :label="item.label" :value="Number(item.value)">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="editVisible = false">取 消</el-button>
          <el-button type="primary" @click="saveEdit">确 定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import {
  getBalanceRulesList,
  saveBalanceRules,
  deleteBalanceRule,
  setBalanceRuleIsvalidate, getBalanceRule,
} from "@/api/balance-rules";
import moment from "moment";
import { getStoreOption } from "@/api/store";

export default {
  name: "BalanceRulesTable",
  data() {
    return {
      query: {
        recharge: "",
        is_validate: null,
        page: 1,
        page_size: 10
      },
      actTitle: "添加",
      form: {}, //提交表单数据
      tableData: [],
      pageTotal: 0,
      editVisible: false,
      storeOptions: [],
      activeName: 'local-rules',
      storeMap: new Map()
    };
  },
  created() {
    this.getData();
    this.getStoreOptions()
  },
  methods: {
    dateFormat: function (row, column) {
      const date = row[column.property];
      if (date === undefined) {
        return "";
      }
      return moment(parseInt(date + "000")).format("YYYY-MM-DD")
    },
    // 触发搜索按钮
    handleSearch() {
      this.query.page = 1
      this.getData()
    },
    // 搜索套餐
    getData() {
      getBalanceRulesList(this.query).then(res => {
        this.tableData = res.data
        if (this.query.page === 1) {
          this.pageTotal = res.count
        }
      })
    },
    save(row) {
      saveBalanceRules(row.id, row).then(res => {
        if (res) {
          this.$message.success('保存成功')
        }
        this.getData()
      })
    },

    // 删除操作
    handleDelete(id) {
      // 二次确认删除
      this.$confirm("确定要删除吗？", "删除提示", {
        type: "warning"
      }).then(() => {
        deleteBalanceRule(id).then(res => {
          if (res === true) {
            this.$message.success("删除成功")
            this.getData()
          }
        })
      }).catch(() => {
      });
    },

    // 分页导航
    handlePageChange(val) {
      this.query.page = val
      this.getData()
    },

    handleEdit(index, row) {
      this.idx = index;

      getBalanceRule(row.id).then(res => {
        this.actTitle = "编辑"
        this.form = res
        this.form.recharge = parseFloat(this.form.recharge / 100).toFixed(2)
        this.form.deposit = parseFloat(this.form.deposit / 100).toFixed(2)
      }).then(
        this.editVisible = true
      )
    },

    // 添加操作
    handleAdd() {
      this.form = {}
      this.form.id = 0
      this.editVisible = true
    },

    saveEdit() {
      let paramData = Object.assign({}, this.form)
      paramData.recharge = parseInt(this.form.recharge * 100)
      paramData.deposit = parseInt(this.form.deposit * 100)
      paramData.store_id = Number(paramData.store_id)
      saveBalanceRules(this.form.id, paramData).then(res => {
        if (res === true) {
          this.$message.success("保存成功")
          this.getData()
          this.editVisible = false
        }
      })
    },


    setIsvalidate(index, id, isvalidate) {
      setBalanceRuleIsvalidate(id, isvalidate).then(res => {
        if (res === true) {
          this.$message.success('保存成功')
          this.tableData[index].is_validate = isvalidate
        }
      })
    },
    getStoreOptions() {
      getStoreOption().then(res => {
        let that = this
        res.unshift({ label: "平台通用", value: 0 })
        res.forEach(function (item) {
          that.storeMap.set(Number(item.value), item.label)
        })
        this.storeOptions = res
      })
    },

    // eslint-disable-next-line no-unused-vars
    handleAvatarSuccess(res, file) {
      this.form.cover = res.url
    },
    // eslint-disable-next-line no-unused-vars
    handleListSuccess(res, file) {
      this.form.image_list.push(res.url)
    }
  }
};
</script>

<style scoped>
.handle-box {
  margin-bottom: 10px;
}

.handle-select {
  width: 120px;
}

.handle-input {
  width: 200px;
  display: inline-block;
}

.table {
  width: 100%;
  font-size: 14px;
}

.red {
  color: #ff0000;
}

.mr10 {
  margin-right: 10px;
}

.table-td-thumb {
  display: block;
  margin: auto;
  width: 40px;
  height: 40px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.el-dialog__body {
  height: 50vh;
  overflow: auto;
}

.model-h {
  height: 20%;
}
</style>
